import { createRoute } from '@tanstack/react-router';
import { Route as parent } from './site.tsx';
export const Route = createRoute({ getParentRoute: () => parent, path: 'header-footer' }).lazy(() =>
  import('./site-header-footer.lazy.tsx').then((module) => module.Route),
);
